package com.exura.features.publicplans.domain.usecase

import com.exura.features.publicplans.domain.model.ProviderPublicPlan
import com.exura.features.publicplans.domain.repository.ProviderPublicPlanRepository
import kotlinx.coroutines.flow.Flow

class GetPublicPlanUseCase(
    private val repository: ProviderPublicPlanRepository,
) {
    suspend operator fun invoke(id: String): Result<ProviderPublicPlan> {
        return repository.read(id)
    }
}
